export enum ItinerarySortType {
  CODE = 'CODE',
  TIMES_USED = 'TIMES_USED',
  DISTANCE = 'DISTANCE',
  DURATION = 'DURATION',
  CREATION = 'CREATION',
  LAST_USE = 'LAST_USE',
}
